<div class="laskelmat-container">
  <form class="laskelmat-controls">
    <div class="filters-container" [style.justify-content]="valittuValilehti === 'paakirja' ? 'space-between' : 'flex-end'">
      @if (kirjanpitajaOnLuottoObservable | async) {
        <div class="form-boxes" style="width: 155px; margin-right: 10px">
          <mat-select [formField]="lomake.source">
            <mat-option value="raportointikirjaukset">Raportointikirjaukset</mat-option>
            <mat-option value="nippudokumentit">Raportointiniput</mat-option>
          </mat-select>
        </div>
      }

      @if (valittuValilehti === 'paakirja') {
        <div class="form-boxes" style="width: 155px; margin-right: 10px">
          <div class="rounded-input">
            <input #toimittajaInput type="text" [matAutocomplete]="toimittajaAuto" [formField]="lomake.toimittaja" matInput placeholder="Rajaa toimittajalla" data-lpignore="true" (focus)="onToimittajaFocus()" />
            @if (valittuToimittaja) {
              <i style="cursor: pointer; font-size: 20px" matSuffix class="icon ion-ios-close" (click)="poistaValittuToimittaja()"></i>
            }
          </div>
          <mat-autocomplete #toimittajaAuto="matAutocomplete" [displayWith]="toimittajaDisplayFn" [panelWidth]="350">
            @for (toimittaja of suodatetutToimittajat | async; track toimittaja) {
              <mat-option [value]="toimittaja"> {{ toimittaja.numero }} {{ toimittaja.nimi }} {{ toimittaja.ytunnus ? `(${toimittaja.ytunnus})` : '' }} </mat-option>
            }
          </mat-autocomplete>
        </div>
        <div class="form-boxes" style="width: 155px; margin-right: 10px">
          <div class="rounded-input" style="width: 100%; padding: 0 8px">
            <mat-select [formField]="lomake.maksutavanTunniste" placeholder="Rajaa lajilla" style="width: 100%">
              <mat-option [value]="null">Kaikki lajit</mat-option>
              @for (maksutapa of maksutavatRajaukseenObservable | async; track maksutapa.tunniste) {
                <mat-option [value]="maksutapa.tunniste">{{ maksutapa.nimi }}</mat-option>
              }
            </mat-select>
          </div>
        </div>
      }

      @if (valittuValilehti === 'paakirja') {
        <div class="form-boxes">
          <div class="rounded-input">
            <span class="icon ion-ios-search"></span>
            <input style="border: 0; outline: none; width: 100%" type="text" [formField]="lomake.searchString" placeholder="Etsi kirjausta..." data-lpignore="true" />
          </div>
        </div>
        <div class="form-boxes" style="width: 140px">
          <div class="rounded-input">
            <input #tilistaInput style="border: 0; outline: none; width: 100%" decimalNumberField [numberOfDecimals]="0" [formField]="lomake.tilista" placeholder="0001" data-lpignore="true" minlength="4" (keydown.enter)="enterPressedTilista($event)" />
          </div>
          @if (onkoVirhe(lomake.tilista, 'minlength') && (lomake.tilista().dirty() || lomake.tilista().touched())) {
            <mat-error>Kirjoita 4 numeroa.</mat-error>
          }
          @if (onkoVirhe(lomake.tilista, 'pattern') && (lomake.tilista().dirty() || lomake.tilista().touched())) {
            <mat-error>Syötä vain numeroita.</mat-error>
          }
          <div style="margin: 0 5px">-</div>
          <div class="rounded-input">
            <input #tiliinInput style="border: 0; outline: none; width: 100%" decimalNumberField [numberOfDecimals]="0" [formField]="lomake.tiliin" placeholder="9999" data-lpignore="true" minlength="4" (keydown.enter)="enterPressedTiliin($event)" />
          </div>
          @if (onkoVirhe(lomake.tiliin, 'minlength') && (lomake.tiliin().dirty() || lomake.tiliin().touched())) {
            <mat-error>Kirjoita 4 numeroa.</mat-error>
          }
          @if (onkoVirhe(lomake.tiliin, 'pattern') && (lomake.tiliin().dirty() || lomake.tiliin().touched())) {
            <mat-error>Syötä vain numeroita.</mat-error>
          }
        </div>
      }

      <div class="form-boxes" style="width: 228px">
        <div class="rounded-input" style="padding: 0 5px 0 8px">
          <input #alkaaInput type="text" [matDatepicker]="alkaaPicker" [formField]="lomake.alkaa" matInput data-lpignore="true" style="width: 70px" />
          <app-icon-button (click)="alkaaPicker.open()" actionId="Raportit: valitse kuukausi (alkaa)" styles="width: 20px; height: 20px; line-height: 20px;">
            <mat-icon style="width: 20px; height: 20px; line-height: 20px; font-size: 16px; top: 0; left: 0; right: 0; bottom: 0; position: absolute">calendar_today</mat-icon>
          </app-icon-button>
          <!-- <mat-datepicker-toggle matSuffix [for]="alkaaPicker"></mat-datepicker-toggle> -->
          <mat-datepicker #alkaaPicker startView="year"></mat-datepicker>
        </div>
        <div style="margin: 0 5px">-</div>
        <div class="rounded-input" style="padding: 0 5px 0 8px">
          <input type="text" [matDatepicker]="loppuuPicker" [formField]="lomake.loppuu" matInput data-lpignore="true" style="width: 70px" />
          <app-icon-button (click)="loppuuPicker.open()" actionId="Raportit: valitse kuukausi (loppuu)" styles="width: 20px; height: 20px; line-height: 20px;">
            <mat-icon style="width: 20px; height: 20px; line-height: 20px; font-size: 16px; top: 0; left: 0; right: 0; bottom: 0; position: absolute">calendar_today</mat-icon>
          </app-icon-button>
          <!-- <mat-datepicker-toggle matSuffix [for]="loppuuPicker"></mat-datepicker-toggle> -->
          <mat-datepicker #loppuuPicker startView="year"></mat-datepicker>
        </div>
        @if (onkoVirhe(lomake.loppuu, 'required')) {
          <div class="error-text">Päättymispäivämäärä on an&shy;net&shy;ta&shy;va.</div>
        }
        @if (onkoVirhe(lomake.alkaa, 'required')) {
          <div class="error-text">Alkamispäivämäärä on an&shy;net&shy;ta&shy;va.</div>
        }
        @if (onkoVirhe(lomake.loppuu, 'loppuEnnenAlkua')) {
          <div class="error-text">Loppumispäivämäärä on ennen al&shy;ka&shy;mis&shy;päi&shy;vä&shy;mää&shy;rää.</div>
        }
        @if (onkoVirhe(lomake.loppuu, 'minDate') || onkoVirhe(lomake.alkaa, 'minDate')) {
          <div class="error-text">Päivämäärän on oltava vuoden 2010 jäl&shy;keen.</div>
        }
      </div>
    </div>

    <div style="display: flex; flex-flow: row; justify-content: space-between; margin: 0 auto; max-width: 1000px">
      <div class="date-chip-group">
        @for (tilikausi of naytettavatTilikaudetObservable | async; track tilikausi) {
          <app-button [title]="tilikausi?.labelHover || null" (click)="valitseTilikausi(tilikausi)" actionId="Raportit: Valittu: tilikausi" [dynamicClass]="{ 'date-chip-selected': naytettavaTilikausi()?.labelHover === tilikausi.labelHover }" additionalClass="date-chip">
            {{ tilikausi?.label }}
          </app-button>
        }
      </div>

      @if (naytettavaTilikausi()) {
        <div class="date-chip-group">
          @for (qt of naytettavaTilikausi().quarters; track qt) {
            <app-button [title]="qt?.quarter || null" (click)="valitseKvartaali(qt)" actionId="Raportit: Valittu: kvartaali" [dynamicClass]="{ 'date-chip-selected': dateBtnsSelectedQuarter() === qt.quarter }" additionalClass="date-chip">
              {{ qt?.label }}
            </app-button>
          }
        </div>
        <div class="date-chip-group">
          @for (mm of naytettavaTilikausi().months; track mm) {
            <app-button [title]="mm?.month || null" (click)="valitseKuukausi(mm)" actionId="Raportit: Valittu: kuukausi" [dynamicClass]="{ 'date-chip-selected': dateBtnsSelectedMonth() === mm.month }" additionalClass="date-chip">
              {{ mm?.label }}
            </app-button>
          }
        </div>
      }
    </div>

    @if (naytaProjektitObservable | async) {
      <div style="text-align: center; height: 35px">
        @if (valittuValilehti !== 'viralliset') {
          <app-kirjanpito-projektit-dropdown [projektitFromParentObservable]="kaikkiKirjanpitoprojektitObservable" (projektiValittu)="filterByProject($event)"></app-kirjanpito-projektit-dropdown>
        }
      </div>
    }

    <!-- <button mat-button type="button" (click)="paivitaArvot()">Päivitä arvot</button> -->
  </form>

  <div style="display: flex; flex-flow: row wrap; justify-content: center">
    <div class="report-btn-group">
      <app-button (click)="setValittuValilehti('tase-ja-tulos')" actionId="Raportit: Valittu välilehti: Tase ja tulos" [dynamicClass]="{ 'report-btn-selected': valittuValilehti === 'tase-ja-tulos' }" additionalClass="report-btn padded">
        <div>Tase ja Tulos</div>
      </app-button>
      <!-- <button class="report-btn" mat-button [class.report-btn-selected]="valittuValilehti === 'tase'" (click)="setvalittuValilehti('tase')">
      <div>Tase</div>
    </button>
    <button class="report-btn" mat-button [class.report-btn-selected]="valittuValilehti === 'tulos'" (click)="setvalittuValilehti('tulos')">
      <div>Tulos</div>
    </button> -->
      <app-button (click)="setValittuValilehti('viralliset')" actionId="Raportit: Valittu välilehti: Viralliset (tase ja tulos)" [dynamicClass]="{ 'report-btn-selected': valittuValilehti === 'viralliset' }" additionalClass="report-btn padded">
        <div>Viralliset</div>
      </app-button>
      <!-- <button class="report-btn" mat-button [class.report-btn-selected]="valittuValilehti === 'tulos-virallinen'" (click)="setvalittuValilehti('tulos-virallinen')">
    <div>Virallinen tulos</div>
  </button>
  <button class="report-btn" mat-button [class.report-btn-selected]="valittuValilehti === 'tase-virallinen'" (click)="setvalittuValilehti('tase-virallinen')">
    <div>Virallinen tase</div>
  </button> -->
      <app-button (click)="setValittuValilehti('paakirja')" actionId="Raportit: Valittu välilehti: Pääkirja" [dynamicClass]="{ 'report-btn-selected': valittuValilehti === 'paakirja' }" additionalClass="report-btn padded">
        <div>Pääkirja</div>
      </app-button>
      <app-button (click)="setValittuValilehti('bruttolaskelma')" actionId="Raportit: Valittu välilehti: Bruttolaskelma" [dynamicClass]="{ 'report-btn-selected': valittuValilehti === 'bruttolaskelma' }" additionalClass="report-btn padded">
        <div>Bruttolaskelma</div>
      </app-button>
      <app-button (click)="setValittuValilehti('alv-laskelma')" actionId="Raportit: Valittu välilehti: ALV-laskelma" [dynamicClass]="{ 'report-btn-selected': valittuValilehti === 'alv-laskelma' }" additionalClass="report-btn padded">
        <div>ALV-laskelma</div>
      </app-button>
      @if (naytaOss()) {
        <app-button (click)="setValittuValilehti('oss-myynnit')" actionId="Raportit: Valittu välilehti: Erityisjärjestelmämyynnit" [dynamicClass]="{ 'report-btn-selected': valittuValilehti === 'oss-myynnit' }" additionalClass="report-btn padded">
          <div>Erityisjärjestelmämyynnit</div>
        </app-button>
      }
    </div>

    <div class="pdf-btn-row">
      @if (valittuValilehti !== 'oss-myynnit') {
        <app-button (click)="openPdfSelect()" actionId="Avaa pdf:n latausvalikko">
          <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512" style="height: 20px; vertical-align: middle">
            <path d="M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56M192 400.1l64 63.9 64-63.9M256 224v224.03" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" />
          </svg>
          Lataa PDF
        </app-button>
      }
      <div class="hidden-select">
        @if (valittuValilehti !== 'oss-myynnit') {
          <mat-select #pdfSelect panelClass="no-scroll">
            @for (pdf of pdfList; track pdf) {
              <mat-option (click)="downloadPdf(pdf.type, pdf.kieli)">
                {{ pdf.tag }}
              </mat-option>
            }
          </mat-select>
        }
      </div>

      @if (valittuValilehti === 'tase-ja-tulos' || valittuValilehti === 'paakirja') {
        <app-button (click)="openCsvSelect()" actionId="Avaa excelin latausvalikko">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000" style="height: 20px; vertical-align: middle">
            <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm240-240H200v160h240v-160Zm80 0v160h240v-160H520Zm-80-80v-160H200v160h240Zm80 0h240v-160H520v160ZM200-680h560v-80H200v80Z" />
          </svg>
          Lataa Excel
        </app-button>
      }
      <div class="hidden-select">
        @if (valittuValilehti === 'tase-ja-tulos' || valittuValilehti === 'paakirja') {
          <mat-select #csvSelect panelClass="no-scroll">
            @for (csv of csvList; track csv) {
              <mat-option (click)="downloadCsv(csv.type, csv.kieli)">
                {{ csv.tag }}
              </mat-option>
            }
          </mat-select>
        }
      </div>
    </div>

    @if (valittuValilehti === 'tase-ja-tulos') {
      <div
        [style.order]="taseOrderObservable | async"
        app-kirjanpito-taselaskelma
        [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable"
        [tilitMapObservable]="tilitVertailuMapObservable"
        [paivitaArvotHiljaisestiSubject]="paivitaArvotHiljaisestiSubject"
        [taseEnsin]="(taseOrderObservable | async) === '1'"
        (tulosEnsinClicked)="setTulosTaseEnsin('tulos')"
        class="raportti-container"
        (kirjaustaKlikattiin)="emitKirjausData($event)"
      ></div>
    }
    @if (valittuValilehti === 'tase-ja-tulos') {
      <div
        [style.order]="tulosOrderObservable | async"
        app-kirjanpito-tuloslaskelma
        [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable"
        [tilitMapObservable]="tilitVertailuMapObservable"
        [paivitaArvotHiljaisestiSubject]="paivitaArvotHiljaisestiSubject"
        class="raportti-container"
        (kirjaustaKlikattiin)="emitKirjausData($event)"
        [tulosEnsin]="(tulosOrderObservable | async) === '1'"
        (taseEnsinClicked)="setTulosTaseEnsin('tase')"
      ></div>
    }
    @if (valittuValilehti === 'viralliset') {
      <div
        [style.order]="taseOrderObservable | async"
        app-kirjanpito-taselaskelma-virallinen
        [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable"
        [tilitMapObservable]="tilitMapObservable"
        [paivitaArvotHiljaisestiSubject]="paivitaArvotHiljaisestiSubject"
        class="raportti-container viralliset"
        [taseEnsin]="(taseOrderObservable | async) === '1'"
        (tulosEnsinClicked)="setTulosTaseEnsin('tulos')"
      ></div>
    }
    @if (valittuValilehti === 'viralliset') {
      <div
        [style.order]="tulosOrderObservable | async"
        app-kirjanpito-tuloslaskelma-virallinen
        [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable"
        [tilitMapObservable]="tilitMapObservable"
        [paivitaArvotHiljaisestiSubject]="paivitaArvotHiljaisestiSubject"
        class="raportti-container viralliset"
        [tulosEnsin]="(tulosOrderObservable | async) === '1'"
        (taseEnsinClicked)="setTulosTaseEnsin('tase')"
      ></div>
    }
    @if (valittuValilehti === 'paakirja') {
      <div app-kirjanpito-paakirja [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable" [tilitMapObservable]="tilitMapObservable" [paivitaArvotHiljaisestiSubject]="paivitaArvotHiljaisestiSubject" (kirjaustaKlikattiin)="emitKirjausData($event)" class="raportti-container"></div>
    }
    @if (valittuValilehti === 'bruttolaskelma') {
      <div app-kirjanpito-tuloslaskelma-brutto [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable" [tilitMapObservable]="tilitMapObservable" [paivitaArvotHiljaisestiSubject]="paivitaArvotHiljaisestiSubject" (kirjaustaKlikattiin)="emitKirjausData($event)" class="raportti-container"></div>
    }
    @if (valittuValilehti === 'alv-laskelma') {
      <div app-kirjanpito-alv-laskelma [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable" [tilitMapObservable]="tilitMapObservable" [paivitaArvotHiljaisestiSubject]="paivitaArvotHiljaisestiSubject" (kirjaustaKlikattiin)="emitKirjausData($event)" class="raportti-container"></div>
    }
    @if (valittuValilehti === 'oss-myynnit') {
      <div app-kirjanpito-oss [hakuvaihtoehdotObservable]="hakuvaihtoehdotObservable" [tilitMapObservable]="tilitMapObservable" [paivitaArvotHiljaisestiSubject]="paivitaArvotHiljaisestiSubject" (kirjaustaKlikattiin)="emitKirjausData($event)" class="raportti-container"></div>
    }
  </div>
</div>
